export enum RepresentativeRole {
  BUSINESS_ADMIN = 'BUSINESS_ADMIN',
  BUSINESS_REPRESENTATIVE = 'BUSINESS_REPRESENTATIVE',
  RESELLER = 'RESELLER',
  EPSON_ADMIN = 'EPSON_ADMIN',
}
